module.exports = __webpack_public_path__ + "img/p_hybrid.6d590cd6.jpg";